import { castArray } from '@utils/guards'

// const argumentsToArray = (...methodArguments) => methodArguments
// export const juxt = converge(argumentsToArray)

export const applyArray = methods => array => methods
  .map((method, index) => method(array[index]))

export const optionallyCall = (function_, functionArguments = [], thisArgument = null) =>
  typeof function_ === 'function'
    ? function_.apply(thisArgument, castArray(functionArguments))
    : function_

export const nothing = () => {}
